import { render, staticRenderFns } from "./LangPicker.vue?vue&type=template&id=96e18e28&scoped=true&"
import script from "./LangPicker.vue?vue&type=script&lang=js&"
export * from "./LangPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e18e28",
  null
  
)

export default component.exports